import { RecordForActions } from '../EmployeeActionsUtils';
import { WaiveCoverageFormBulk } from './WaiveCoverageFormBulk';
import { WaiveCoverageFormSingle } from './WaiveCoverageFormSingle';

type WaiveCoverageFormProps = {
  recordsForActions: RecordForActions[];
  onSuccess: () => void;
  onClose: () => void;
};

export const WaiveCoverageForm = ({
  recordsForActions,
  onSuccess,
  onClose,
}: WaiveCoverageFormProps) => {
  const isSingleEmployee = recordsForActions.length === 1;
  const singleEmployee = recordsForActions[0];

  if (isSingleEmployee) {
    const { employeeId, employerId, onboardingPeriodId } = singleEmployee;

    if (!onboardingPeriodId) {
      return null;
    }

    return (
      <WaiveCoverageFormSingle
        employeeId={employeeId}
        employerId={employerId}
        onboardingPeriodId={onboardingPeriodId}
        onSuccess={onSuccess}
        onClose={onClose}
      />
    );
  }

  return (
    <WaiveCoverageFormBulk
      recordsForActions={recordsForActions}
      onSuccess={onSuccess}
      onClose={onClose}
    />
  );
};
